export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-contrast-2d6e23e0d02a12a9c998bfc879e18a45.svg";